module.exports = __webpack_public_path__ + "catalog/items/heating_Electrical/Fridge/Fridge.svg";